export const CLIENT_TYPES = [
  { value: "Buyer", label: "Buyer" },
  { value: "Seller", label: "Seller" },
  { value: "Both", label: "Both" },
];

export const STAGES = [
  { value: "New Lead", label: "New Lead" },
  { value: "Active", label: "Active" },
  { value: "Under Contract", label: "Under Contract" },
  { value: "Closed", label: "Closed" },
  { value: "Lost", label: "Lost" },
];
